import { database } from '../index';
import { SALE_ORDER_SCHEMA, SALE_ORDER_LINE_SCHEMA, BUSINESS_SCHEMA } from '../schema';
import { Q } from '@nozbe/watermelondb';
import { stockCalculation } from './stock';
import { uuid } from "../../oscar-pos-core/constants";

const saleOrder = database.collections.get(SALE_ORDER_SCHEMA);


export const getSaleOrderByID = async (id) => await saleOrder.find(id)


export const getSaleOrderByIdObserve = (sale_order_id) =>
    saleOrder
        .query(
            Q.where("id", sale_order_id),
        )
        .observeWithColumns(['discount', 'discount_method', 'tax', 'tax_type']);


export const getActiveSaleOrderByBusiness = async (business_id) =>
    await saleOrder
        .query(
            Q.on(BUSINESS_SCHEMA, [Q.where("id", business_id)]),
            Q.where("status", 'active'),)
        .fetch();

export const observeActiveSaleOrderByBusiness = (business_id) =>
    saleOrder.query(
        Q.on(BUSINESS_SCHEMA, [Q.where("id", business_id)]),
        Q.where("status", 'active'))
        .observe();



export const ObserveDraftSaleOrderByBusiness = (business_id) => saleOrder
    .query(
        Q.where("business_id", business_id),
        Q.where("status", 'draft'))
    .observeWithColumns(['status']);


export const createSaleOrderLine = async (item, saleOrderinstant) => {
    await database.write(async () => {
        const [stock, is_secondary] = await stockCalculation(item);
        return await
            database.collections.get(SALE_ORDER_LINE_SCHEMA).create((saleOrderLine) => {
                saleOrderLine.sale_order.set(saleOrderinstant);
                saleOrderLine._raw.id = uuid()
                if (!item?.is_open_item) {
                    saleOrderLine.stock.set(stock);
                }
                saleOrderLine.name = stock.name
                saleOrderLine.quantity = item.quantity
                saleOrderLine.unit = stock?.unit
                saleOrderLine.cost_price = item.cost_price
                saleOrderLine.selling_price = item?.selling_price
                saleOrderLine.tax = stock?.tax || null
                saleOrderLine.inclusive = stock?.inclusive || true
                saleOrderLine.type = 'sales'
                saleOrderLine.transacted_at = new Date().getTime()
                saleOrderLine.discount = item?.discount || 0
                saleOrderLine.discount_method = item?.discount_method || 'rs'
                saleOrderLine.is_open_item = item?.is_open_item || false
                saleOrderLine.tran_type = null
                saleOrderLine.secondary_unit = stock?.secondary_unit || null
                saleOrderLine.is_secondary_unit = is_secondary
                saleOrderLine.unit_conversion = stock?.unit_conversion || null
            })
    });
};

export const deleteSaleOrderById = async (id) => {
    await database.write(async () => {
        const saleOrder = await getSaleOrderByID(id)
        await saleOrder.destroyPermanently();
    });
}

export const updateSaleOrderStatusById = async (id, status) => {
    await database.write(async () => {
        const saleOrder = await getSaleOrderByID(id)
        await saleOrder.update((item) => {
            item.status = status;

        });
    });
}